var map = {
	"./dog1.jpg": 313,
	"./dog10.jpg": 293,
	"./dog11.jpg": 75,
	"./dog12.jpg": 167,
	"./dog2.jpg": 328,
	"./dog3.jpg": 114,
	"./dog4.jpg": 776,
	"./dog5.jpg": 798,
	"./dog6.jpg": 373,
	"./dog7.jpg": 40,
	"./dog8.jpg": 17,
	"./dog9.jpg": 405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 466;